export function is_user_active(user) {
  return user.status === "active";
}
